import { render, staticRenderFns } from "./registerFooter.vue?vue&type=template&id=41861298&scoped=true"
import script from "./registerFooter.vue?vue&type=script&lang=js"
export * from "./registerFooter.vue?vue&type=script&lang=js"
import style0 from "./registerFooter.vue?vue&type=style&index=0&id=41861298&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41861298",
  null
  
)

export default component.exports